<!-- <div class="col-12">
  <div>
      <span style="font-size: 18px"> <b> Note: Response should be submitted on or before {{responsedate}} </b> </span>
  </div>
</div> -->

<!-- <div class="col-12">
    <div>
        <span> <b>
            <mark style="background-color: yellow;font-size: 18px;color: darkblue;">
              To enable this page, please ensure your Project Team Members & Disciplines are selected in EIP Staff Selection page  
        </mark>
        </b> 
        </span>
        
    </div>
  </div> -->

<div class="col-12">
  <form [formGroup]="formGroup">
      <kendo-grid [kendoGridBinding]="responseList" [pageSize]="20" [selectable]="true" [pageable]="true" [sortable]="true" [resizable]="true" (edit)="editHandler($event)" (cancel)="cancelHandler($event)" (save)="saveHandler($event)" (excelExport)="onExcelExport($event)" [filterable]="enableFilter">
          <ng-template kendoGridToolbarTemplate>
              <div class="k-grid-toolbar-content d-flex justify-content-end">
                  <div class="icons-container">
                      <!-- <div class="icon-wrap">
                        <i class="fa fa-chain" title="Create Impact" (click)="addImpacts()" aria-hidden="true"></i>
                      </div> -->
                      <div class="icon-wrap">
                          <i class="fa fa-filter" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
                      </div>
                      <div class="icon-wrap">
                          <button type="button" class="btn btn-primary eip-ml-20 eip-mr-20 eip-p-10" style="background: #1579ab;padding: 5px;" kendoGridExcelCommand icon="file-excel">Export to
                              Excel</button>
                      </div>
                  </div>
              </div>
          </ng-template>
          <ng-template kendoPagerTemplate>
              <div class="k-pager-left">
                  <kendo-pager-info></kendo-pager-info>
              </div>
              <div class="k-pager-right">
                  <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                  <kendo-pager-input></kendo-pager-input>
                  <kendo-pager-next-buttons></kendo-pager-next-buttons>
              </div>
          </ng-template>
          <kendo-grid-column title="Sl_No" field="Sl_No" width="50">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  {{rowIndex+1}}
              </ng-template>
          </kendo-grid-column>
          <!-- <kendo-grid-checkbox-column showSelectAll="true" width="50">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <div *ngIf="dataItem.responder_Agreed =='Y'">
                <input [kendoGridSelectionCheckbox]="rowIndex" />
              </div>
            </ng-template>
          </kendo-grid-checkbox-column> -->
          <kendo-grid-column title="Discipline / code" field="discipline" width="100">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  {{dataItem.discipline}} {{ dataItem.disc_No ? ' - '+dataItem.disc_No:''}}
              </ng-template>
          </kendo-grid-column>
          <!-- <kendo-grid-column title="Discipline" field="disc_No" width="50">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <div *ngIf="dataItem.disc_No" style="text-align: center;">
                      {{dataItem.disc_No}}
                  </div>
              </ng-template>
          </kendo-grid-column> -->
          <kendo-grid-column title="Panel Comments" field="panel_Comments" width="150" >
            <!-- <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <i aria-hidden="true" class="fa fa-paperclip fs-16 eip-mr-5 eip-link" title="Attachment" (click)="viewAttachmentClick(dataItem)"></i>
            </ng-template>  -->
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <span class="no-wrap" eipTooltip="{{dataItem.panel_Comments}}" eipTooltipPosition="auto">
                    <i aria-hidden="true" *ngIf="dataItem.comments_Attachments=='Y'" class="fa fa-paperclip fs-16 eip-mr-5 eip-link" title="Attachment" (click)="viewAttachmentClick(dataItem)"></i>
                      {{dataItem.panel_Comments}}
                  </span>
              </ng-template>
          </kendo-grid-column>

          <kendo-grid-column title="Comment Type / Category" field="potential_Comment" width="200">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <div class="row d-flex">
                <div class="col-xl-8 col-xs-8 col-md-8 col-sm-12">
                  {{dataItem.potential_Comment}}
                </div>
                <div class="col-xl-4 col-xs-4 col-md-4 col-sm-12">
                  <span *ngIf="dataItem.category=='Medium Risk'">
                    <p style="width: 25px;height: 25px; background-color: #ffbf00;margin-top: 5px;"></p> 
                  </span>
                  <span *ngIf="dataItem.category=='High Risk'">
                    <p style="width: 25px;height: 25px; background-color: red;margin-top: 5px;"></p>
                  </span>
                  <span *ngIf="dataItem.category=='Low Risk'">
                    <p style="width: 25px;height: 25px; background-color: darkgreen;margin-top: 5px;"></p>
                  </span>
                </div>
              </div>
              </ng-template>
          </kendo-grid-column>

          <!-- <kendo-grid-column title="Comment Category" field="category" width="110">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <div *ngIf="dataItem.category=='Medium Risk'" style="padding:5px;background-color: #ffbf00; font-weight: 1000;color:#fff">
                      {{dataItem.category}}
                  </div>
                  <div *ngIf="dataItem.category=='High Risk'" style="padding:5px;background-color: red; font-weight: 1000;color:#fff">
                      {{dataItem.category}}
                  </div>
                  <div *ngIf="dataItem.category=='Low Risk'" style="padding:5px;background-color: darkgreen; font-weight: 1000;color:#fff">
                      {{dataItem.category}}
                  </div>
              </ng-template>
          </kendo-grid-column> -->
          <kendo-grid-column title="Submitted By" field="submitted_By" width="120">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  {{dataItem.submitted_By}}
              </ng-template>
          </kendo-grid-column>
          <!-- <kendo-grid-column title="Submitted On" field="submitted_On" width="100">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  {{dataItem.submitted_On | date:'dd-MMM-yyyy'}}
              </ng-template>
          </kendo-grid-column> -->
          <!-- <kendo-grid-column title="Attachments" width="80">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <i aria-hidden="true" class="fa fa-paperclip fs-16 eip-mr-5 eip-link" title="Attachment" (click)="viewAttachmentClick(dataItem)"></i>
              </ng-template>
          </kendo-grid-column> -->
          <kendo-grid-column title="Response by Project" field="responder_Agreed" width="180">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <div *ngIf="dataItem.responder_Agreed==='Y'">
                    <span class="no-wrap" eipTooltip="Comply - {{dataItem.action_Remarks}}" eipTooltipPosition="auto">
                      Comply - {{dataItem.action_Remarks}}
                    </span>
                  </div>
                  <div *ngIf="dataItem.responder_Agreed==='N'">
                    <span class="no-wrap" eipTooltip="Unable to Comply - {{dataItem.reason_Remarks}}" eipTooltipPosition="auto">
                      Unable to Comply - {{dataItem.reason_Remarks}}
                    </span>
                  </div>
              </ng-template>
              <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <mat-form-field width="120">
                    <mat-label>Select Response</mat-label>
                    <mat-select [(value)]="isAgree" required>
                        <mat-option value='Y'>Comply</mat-option>
                        <mat-option value='N'>Unable to Comply</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" *ngIf="isAgree=='Y'">
                  <mat-label>Action</mat-label>
                  <textarea matInput formControlName="remarks" required cols="25" rows="5" ></textarea>
                </mat-form-field>
                <div *ngIf="isAgree=='N'">
                  <!-- <mat-form-field>
                      <mat-label>Select Reason</mat-label>
                      <mat-select required formControlName="reason_dropdown" required>
                          <mat-option *ngFor="let data of reasonDropdown" [value]="data.deD_Id">
                              {{data.deD_Description}}
                          </mat-option>
                      </mat-select>
                  </mat-form-field> -->
                  <mat-form-field appearance="outline">
                      <mat-label></mat-label>
                      <textarea matInput formControlName="reason_text" required cols="30" rows="5"></textarea>
                  </mat-form-field>
              </div>
                
                <!-- <div *ngIf="!dataItem.impact">
                    <mat-form-field width="100">
                        <mat-label>Select Response</mat-label>
                        <mat-select [(value)]="isAgree" required>
                            <mat-option value='Y'>Comply</mat-option>
                            <mat-option value='N'>Unable to Comply</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div *ngIf="dataItem.impact">
                    <div *ngIf="dataItem.responder_Agreed==='Y'">
                        Comply
                    </div>
                    <div *ngIf="dataItem.responder_Agreed==='N'">
                        Unable to Comply
                    </div>
                </div> -->
              </ng-template>
          </kendo-grid-column>
          <!-- <kendo-grid-column title="Response Status" field="Response_Status" width="100">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <div *ngIf="dataItem.responder_Agreed">
                      Saved
                  </div>
              </ng-template>
          </kendo-grid-column> -->
          <!-- <kendo-grid-column title="Responded On" field="responded_On" width="100">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  {{dataItem.responded_On | date:'dd-MMM-yyyy'}}
              </ng-template>
          </kendo-grid-column> -->
          <!-- <kendo-grid-column title="Action" field="action_Remarks" width="200">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <span class="no-wrap" eipTooltip="{{dataItem.action_Remarks}}" eipTooltipPosition="auto">
                      {{dataItem.action_Remarks}}
                  </span>
              </ng-template>
              <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <div *ngIf="isAgree=='Y'">
                      <mat-form-field>
                          
                          
                      </mat-form-field>
                  </div>
              </ng-template>
          </kendo-grid-column> -->
          <kendo-grid-column title="Action By / date" field="action_By" width="150">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <span class="no-wrap" eipTooltip="{{dataItem.action_By}} {{dataItem.action_Date ? ' / '+(dataItem.action_Date | date:'dd-MMM-yyyy') :''}}" eipTooltipPosition="auto"></span>
              {{dataItem.action_By}} {{dataItem.action_Date ? ' - '+(dataItem.action_Date | date:'dd-MMM-yyyy') :''}} 
            </ng-template>
              <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <div *ngIf="isAgree=='Y'">
                      <mat-form-field appearance="outline">
                          <mat-label>Action By</mat-label>
                          <textarea matInput formControlName="from" required cols="25" rows="5"></textarea>
                      </mat-form-field>
                      <EIPDatePicker setid="txtDocDate" WaterMark="Action Date" [Value]="dataItem.action_Date" [Min]=min required (selectedDate)='getValue($event,rowIndex)'>
                      </EIPDatePicker>
                  </div>
              </ng-template>
          </kendo-grid-column>
          <!-- <kendo-grid-column title="Action On" field="action_Date" width="160">
              
              <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <div *ngIf="isAgree=='Y'">
                      
                  </div>
              </ng-template>
          </kendo-grid-column> -->

          <!-- <kendo-grid-column title="Action Taken" field="impactOpenClose" width="180" >
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <span class="no-wrap" eipTooltip="{{dataItem.impactStatus ? dataItem.impactStatus:''}} {{dataItem.impactDateClosure ? ' - '+(dataItem.impactDateClosure | date:'dd-MMM-yyyy'):''}}" eipTooltipPosition="auto">
                  {{dataItem.impactStatus ? dataItem.impactStatus:''}} {{dataItem.impactDateClosure ? ' - '+(dataItem.impactDateClosure | date:'dd-MMM-yyyy'):''}}
                </span>
              </ng-template>
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <div *ngIf="isAgree=='Y'">
                    <!-- <mat-form-field>
                        <mat-label>Open/Closed *</mat-label>
                        <mat-select [disabled]="setDisable" formControlName="impactOpenClose" (selectionChange)="onChangeImpactyesno($event)">
                          <mat-option *ngFor="let data of impactopenclose" [value]="data">
                            {{data}}
                          </mat-option>
                        </mat-select>
                    </mat-form-field> 
                    <mat-form-field>
                      <mat-label>Action with</mat-label>
                      <mat-select [disabled]="setDisable" formControlName="impactStatus_DED_ID" (selectionChange)="onChangeImpactstatewith($event)">
                        <mat-option *ngFor="let data of impactstatus" [value]="data.deD_Id">
                          {{data.deD_Description}}
                        </mat-option>
                      </mat-select>
                  </mat-form-field>
                  <EIPDatePicker setid="txtImpactDate" WaterMark="Date of Closure"  [Value]="dataItem.impactDateClosure" [Min]="dataItem.action_Date" required (selectedDate)='getImpactDateValue($event,rowIndex)'>
                  </EIPDatePicker>
                </div>
            </ng-template>
          </kendo-grid-column> -->

          <!-- <kendo-grid-column title="Open/Closed With*" field="impactStatus" width="150">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <span class="no-wrap" eipTooltip="{{dataItem.impactStatus}}" eipTooltipPosition="auto">
                  {{dataItem.impactStatus}}
                </span>
              </ng-template>
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <div *ngIf="isAgree=='Y'">
                    
                </div>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column title="Date Closure*" field="impactDateClosure" width="170">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <span class="no-wrap" eipTooltip="{{dataItem.impactDateClosure}}" eipTooltipPosition="auto">
                  {{dataItem.impactDateClosure | date:'dd-MMM-yyyy'}}
                </span>
              </ng-template>
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <div *ngIf="isAgree=='Y'">
                      
                </div>
            </ng-template>
          </kendo-grid-column> -->

          <!-- <kendo-grid-column title="Reasons, if unable to comply" field="reason" [width]="300">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <div *ngIf="dataItem.reason">
                      <span class="no-wrap" eipTooltip="{{dataItem.reason}} - {{dataItem.reason_Remarks}}" eipTooltipPosition="auto">
                          {{dataItem.reason}} -
                          {{dataItem.reason_Remarks}}
                      </span>
                  </div>
              </ng-template>
              <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  
              </ng-template>
          </kendo-grid-column> -->

          <kendo-grid-column title="Evidence Attachments" width="80">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <div *ngIf="dataItem.responder_Agreed==='Y'">
                <i aria-hidden ="true" *ngIf="dataItem.isAttachment!='N'"  class="fa fa-paperclip fs-16 eip-mr-5 eip-link" title="View Attachment" (click)="viewImpactAttachmentClick(dataItem)" style="margin-right: 20px;"></i>
                  <i aria-hidden ="true" *ngIf="dataItem.isAttachment=='N'"   class="fa fa-upload fs-16 eip-mr-5 eip-link" title="Upload Attachment" (click)="uploadAttachmentClick(dataItem)"></i>
              </div>
              <div *ngIf="dataItem.responder_Agreed==='N'">
              </div>
            </ng-template>
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">

            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column title="Impacts" field="impact" width="180">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <span class="no-wrap" eipTooltip="{{dataItem.impact}}" eipTooltipPosition="auto">
                {{dataItem.impact}}
                </span>
            </ng-template>
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <div *ngIf="isAgree=='Y'">
                    <EIPMultiSelectAutoComplete [dataSource]="impactType" setId="ddimpactType"  
                    TextField="deD_Description" ValueField="deD_Id" ShowTextValueField='N' isEmitOnSelect="Y" [defaultSelectedValues]='selectedimpactBind'
                    WaterMarkText="Impact *" (valueChange)="checkedImpact($event)">
                  </EIPMultiSelectAutoComplete>
                </div>
            </ng-template>
          </kendo-grid-column>


          <!-- <kendo-grid-column title="Status" field="impact" width="100">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <span class="no-wrap" eipTooltip="{{dataItem.impact}}" eipTooltipPosition="auto">
                {{dataItem.impact}}
              </span>
            </ng-template>
          </kendo-grid-column> -->
          <!-- <kendo-grid-column title="Evidence Remarks" field="evidence_Remarks" width="100">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <div *ngIf="dataItem.responder_Agreed==='Y'">
                <mat-form-field>
                  <ng-container *ngIf="!dataItem.isSelected">
                    <span class="no-wrap" eipTooltip="{{dataItem.evidence_Remarks}}" eipTooltipPosition="auto">
                      <input matInput [readonly]="!dataItem.isSelected" value={{dataItem.evidence_Remarks}}>
                    </span>
                  </ng-container>
                  <ng-container *ngIf="dataItem.isSelected">
                    <textarea matInput value={{dataItem.evidence_Remarks}} (change)="onValueChange($event, dataItem);" cols="30"></textarea>
                  </ng-container>
                </mat-form-field>
              </div>
              <div *ngIf="dataItem.responder_Agreed==='N'">
                NIL
              </div>
            </ng-template>
          </kendo-grid-column> -->
          <!-- <kendo-grid-column title="Attachments for Impacts" width="100">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <div *ngIf="dataItem.responder_Agreed==='Y'">
                <i aria-hidden ="true"  class="fa fa-paperclip fs-16 eip-mr-5 eip-link" title="View Attachment" (click)="viewImpactAttachmentClick(dataItem)" style="margin-right: 20px;">
                  </i>
                  <i aria-hidden ="true"  class="fa fa-upload fs-16 eip-mr-5 eip-link" title="Upload Attachment" (click)="uploadAttachmentClick(dataItem)"></i>
              </div>
              <div *ngIf="dataItem.responder_Agreed==='N'">
                NIL
              </div>
            </ng-template>
          </kendo-grid-column> -->

          <!-- <kendo-grid-column title="Impact Open/Close" field="impactOpenClose" width="100">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <span class="no-wrap" eipTooltip="{{dataItem.impactOpenClose}}" eipTooltipPosition="auto">
                {{dataItem.impactOpenClose}}
              </span>
            </ng-template>
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <div *ngIf="dataItem.impact">
                    <div *ngIf="dataItem.responder_Agreed==='Y'">
                        <mat-form-field>
                            <mat-label>Open/Closed</mat-label>
                            <mat-select [disabled]="setDisable" (selectionChange)="onChangeImpactyesno($event)">
                              <mat-option *ngFor="let data of impactopenclose" [value]="data">
                                {{data}}
                              </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </ng-template>
          </kendo-grid-column> -->
<!-- 
          <kendo-grid-column title="Impact Status With" field="impactStatus" width="100">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <span class="no-wrap" eipTooltip="{{dataItem.impactStatus}}" eipTooltipPosition="auto">
                {{dataItem.impactStatus}}
              </span>
            </ng-template>
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <div *ngIf="dataItem.impact">
                    <div *ngIf="dataItem.responder_Agreed==='Y'">
                        <mat-form-field>
                            <mat-label>Impact Status With</mat-label>
                            <mat-select [disabled]="setDisable" (selectionChange)="onChangeImpactstatewith($event)">
                              <mat-option *ngFor="let data of impactstatus" [value]="data.deD_Id">
                                {{data.deD_Description}}
                              </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </ng-template>
          </kendo-grid-column> -->

          <!-- <kendo-grid-column title="Impact Date Closure" field="impactDateClosure" width="100">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <span class="no-wrap" eipTooltip="{{dataItem.impactDateClosure}}" eipTooltipPosition="auto">
                {{dataItem.impactDateClosure | date:'dd-MMM-yyyy'}}
              </span>
            </ng-template>
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <div *ngIf="dataItem.impact">
                    <div *ngIf="dataItem.responder_Agreed==='Y'">
                        <EIPDatePicker setid="txtImpactDate" WaterMark="Impact Date Closure" [Value]="dataItem.impactDateClosure" [Min]=min required (selectedDate)='getImpactDateValue($event)'>
                        </EIPDatePicker>
                    </div>
                </div>
            </ng-template>
          </kendo-grid-column> -->

          <kendo-grid-command-column title="" width="80">
              <ng-template kendoGridCellTemplate let-isNew="isNew">
                  <div class="icon-container d-flex">
                      <span kendoGridEditCommand class="setEditIcon">
                          <i class="fa fa-pencil" title="Edit" aria-hidden="true"></i>
                      </span>
                      <span kendoGridSaveCommand class="setEditIcon">
                          <i class="fa fa-save" title="{{ 'Update' }}" aria-hidden="true"></i>
                      </span>
                      <span kendoGridCancelCommand class="setSaveIcon">
                          <i class="fa fa-cancel" title="{{ 'Cancel' }}" aria-hidden="true"></i>
                      </span>
                  </div>
              </ng-template>
          </kendo-grid-command-column>
          <kendo-grid-excel fileName="PeerReviewResponse.xlsx" [fetchData]="allData">
          </kendo-grid-excel>
      </kendo-grid>
  </form>
</div>
<div class="row justify-content-center flex-grow-1" style="margin-top: 10px;" *ngIf="submitflag">
  <mat-checkbox (change)="onChange()">
      <h6 style="margin-top: 10px;">The responses for each of the disciplines has been checked/verified by me.</h6>
  </mat-checkbox>
</div>
<div class="row justify-content-center flex-grow-1" *ngIf="submitflag">
    <!-- <button class="btn btn-primary" *ngIf="saveflag" style="margin-right: 25px;" id="btnUpdate" (click)="saveImpact()">
        Save Impact
    </button> -->
  <button class="btn btn-primary" id="btnUpdate" (click)="finalSubmit()">
      Submit
  </button>
</div>
<div class="col-12" style="margin-top: 50px;">
  <div>
      <div style="width: 40px; height: 20px; margin-right:25px; background-color: red; position:relative; float:left;"></div>
      <div>
          <p>Red: High Risk comment related to major deviation from Codes/Standards, Employer’s & Contract requirements, DBR, Statutory, EHS and Security.</p>
      </div>
  </div>
  <div>
      <div style="width: 40px; height: 20px; margin-right: 25px; background-color: #ffbf00; position:relative; float:left;"></div>
      <div>
          <p>Amber: Medium Risk comments related to Interface and coordination issues, Alternate solutions for cost-time effectiveness. Comments not in Red and Green will be categorised to Amber.</p>
      </div>
  </div>
  <div>
      <div style="width: 40px; height: 20px; margin-right: 25px; background-color: green; position:relative; float:left;"></div>
      <div>
          <p>LGreen colour: Low Risk comments related to more clarity of information, typo-error, legibility issues.</p>
      </div>
  </div>
</div>